module.exports = __webpack_public_path__ + "img/gateio-mobile.109066a8.png";